import React from 'react';
import { isEmpty } from 'lodash/fp';
import { routes } from 'constants/config';
import filterSuggestions from 'utils/filterSuggestions';
import { useToggle } from 'hooks';
import { Icon } from 'ui';
import InfoTooltip from 'components/shared/InfoTooltip';
import ContentLearningLibrary from 'components/shared/ContentLearningLibrary';
import Section, { SectionHeader } from 'components/PathBuilder/Sidebar/Section';
import { useVisibilityGroups } from '../../hooks';

const GroupListingVisibility = ({ event }) => {
  const initialVisibilityGroups = event.visibility_groups;
  const [editing, toggleEditing] = useToggle();
  const visibilityGroups = useVisibilityGroups({
    eventId: event.id,
    initialState: initialVisibilityGroups,
  });
  return (
    <Section>
      <SectionHeader className="d-f jc-sb">
        <span>
          <span className="mr-4">
            {t('in_person_training.event_overview.open_registration.title')}
          </span>
          <InfoTooltip
            tooltip={t(
              'in_person_training.event_overview.open_registration.tooltip',
            )}
          />
        </span>
        {!editing && !isEmpty(visibilityGroups.data) && (
          <button
            type="button"
            className="u-linkBtn fz-base fw-n"
            onClick={toggleEditing}
          >
            <Icon name="edit" className="mr-4" />
            {t('common.edit')}
          </button>
        )}
      </SectionHeader>
      <ContentLearningLibrary
        advanced
        editing={editing}
        onCreateContent={visibilityGroups.create}
        onRemoveContent={visibilityGroups.remove}
        toggleEditing={toggleEditing}
        libraryContents={visibilityGroups.data}
        emptyStateActionText={t(
          'in_person_training.event_overview.open_registration.make_event_visible',
        )}
        removeTooltip={t(
          'in_person_training.event_overview.open_registration.remove_group_visibility',
        )}
        suggestionsProps={{
          url: `${routes.IN_PERSON_TRAINING.PEOPLE}?filter[type][]=Group`,
          mapResponseToSuggestions: response => response.data,
          filterSuggestions: filterSuggestions(
            visibilityGroups.data,
            'group.id',
          ),
          queryParam: 'query',
        }}
      />
    </Section>
  );
};

export default GroupListingVisibility;
